import { datadogRum } from '@datadog/browser-rum'
import { isDataDogRumConsentAccepted } from './utils'
import { useEnvironment } from '../../utils/environment/useEnvironment'
import { getDefaultLogger } from '../logger/logger'
import { BUILD_NUMBER } from '../../config'
import { initDatadog } from '@js-boot/datadog-rum'

let isDataDogInitialized = false

const initDatadogLocal = async (userId: number) => {
  const { isProduction } = useEnvironment()

  if (!isProduction || isDataDogInitialized) return

  const hasDataDogRumConsent = await isDataDogRumConsentAccepted()
  if (!hasDataDogRumConsent) {
    getDefaultLogger().info('DataDog RUM user consent not given, initialization halted.')
    return
  }

  try {
    initDatadog({
      applicationId: 'dade7502-20d7-4fb9-81b4-10df5fc7db39',
      clientToken: 'pub83d322446ed397f9c8699f523f833693',
      componentId: 'central-listings',
      team: 'pepper',
      userId: userId.toString(),
      sessionSampleRate: 50,
      sessionReplaySampleRate: 10, // 5% of overall sessions
      version: BUILD_NUMBER,
    })
    isDataDogInitialized = true
  } catch (error) {
    getDefaultLogger().error('Error during DataDog initialization:', error)
  }
}

const DatadogFactory = {
  addError: (error: Error) => {
    datadogRum.addError(error)
  },
  addAction: datadogRum.addAction,
}

const resetDatadog = () => {
  isDataDogInitialized = false
}

export { initDatadogLocal, DatadogFactory, resetDatadog }
